<template>
	<div>
		<md-button class="md-icon-button" @click="dialogVisible = true">
			<md-icon>help_outline</md-icon>
		</md-button>
		<el-dialog
			append-to-body
			:title="$t('how-to-use')"
			:visible.sync="dialogVisible"
			width="50%"
			:before-close="handleClose"
		>
			<slot></slot>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: "how-to-use",
	data() {
		return {
			dialogVisible: false
		}
	},
	methods: {
		handleClose(done) {
			done()
		}
	}
}
</script>
